"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vimeo_1 = require("./vimeo");
var vimeoDirect_1 = require("./vimeoDirect");
var youtube_1 = require("./youtube");
var prezi_1 = require("./prezi");
var googleDrive_1 = require("./googleDrive");
var pluvo_1 = require("./pluvo");
var h5p_1 = require("./h5p");
var bunnyStream_1 = require("./bunnyStream");
exports.providers = [
    { name: 'vimeo', className: vimeo_1.Vimeo },
    { name: 'vimeoDirect', className: vimeoDirect_1.VimeoDirect },
    { name: 'youtube', className: youtube_1.Youtube },
    { name: 'prezi', className: prezi_1.Prezi },
    { name: 'googleDrive', className: googleDrive_1.GoogleDrive },
    { name: 'pluvo', className: pluvo_1.Pluvo },
    { name: 'h5p', className: h5p_1.H5P },
    { name: 'bunnyStream', className: bunnyStream_1.BunnyStream },
];
